// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__2-rKA","spin":"Spinner_spin__UL528","spinReverse":"Spinner_spinReverse__9Qp-r","primary":"Spinner_primary__oaA3x","light":"Spinner_light__gMsrC"};